module.exports = __webpack_public_path__ + "static/media/top-img_2a.8aefc03c.png";